import './info-summary-component.scss';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from "../../userContext";
import { useSnackbar } from "../../hook/useSnackbar";
import { useZammadContext } from '../../context/ZammadContext';
import { GET_TICKET_BY_ID_ZAMMAD, mapZammadStateToDisplay } from "../../utils/ZammadServices";
import estructuraFormularios from '../../data/estructuraFormularios.json';
import CustomCell from "../custom-cell/custom-cell";

export default function InfoSummary({ infoFrm, idForm, idSolicitud, item, setItem }) {

   
    const [panelTrigger, activePanelTrigger] = useState(false);
    const { startLoader, stopLoader } = useUserContext();
    const { zammadInstance } = useZammadContext();
    const navigate = useNavigate();
    const [columnsFrm, setColumnsFrm] = useState([]);
    const { showSnackbar } = useSnackbar(); 

    const activePanel = () => {
        if(panelTrigger){
            activePanelTrigger(false);
        } else {
            activePanelTrigger(true);
        }
        
    };


    useEffect(() => {
        const fetchData = async () => {
          try {
            await startLoader();

            // Cargar estructura desde JSON, solo campos específicos
            const estructuraFormulario = estructuraFormularios[idForm];
            if (estructuraFormulario) {
              // Filtrar solo los campos que queremos mostrar en el detalle
              const camposFiltrados = estructuraFormulario.campos.filter(campo =>
                ['Title', 'aplicacion_busint', 'modulo'].includes(campo.name)
              );
              setColumnsFrm(camposFiltrados);
            }

            // Obtener ticket desde Zammad
            const responseTicket = await GET_TICKET_BY_ID_ZAMMAD(zammadInstance, idSolicitud);

            // Transformar datos de Zammad a formato esperado
            const ticketData = {
              Estado: mapZammadStateToDisplay(responseTicket.data.state_id),
              Title: responseTicket.data.title,
              Numero: responseTicket.data.number,
              aplicacion_busint: responseTicket.data.aplicacion_busint,
              modulo: responseTicket.data.modulo,
              group_id: responseTicket.data.group_id,
              ...responseTicket.data
            };

            setItem(ticketData);
            await stopLoader();
          } catch (error) {
            await stopLoader();
            console.log(error)
            showSnackbar(
              "Error : " + error.message,
              "error"
            );
          }
        };

        if (zammadInstance) {
          fetchData();
        }

        return () => {
          // Cualquier código de limpieza aquí
        };
    }, [zammadInstance]);  
 

    return ( 
        <div className='info-summary leftSide'> {/* remove class leftSide when want when panel is at the right and add when panel is on the left */}
            {
                item && Object.keys(item).length > 0 ? 
                <div className="info-summary__container">

                    {/* breadcrumb block, add when necessary ok */}
                    <div className="back" ><span onClick={() => navigate('/Home')} >Home</span>/<span onClick={() => navigate(-1)} >Listado de {infoFrm.Title}</span>/ Solicitud</div>

                    {/* cancel block, move above body when the panel is on the left, move after body when is on the right*/}
                    {/* 
                    // TODO: aplicar la cancelacion de una solicitud
                    <div className="info-summary__btn">
                        <span className="timer">{formatTime(seconds)}</span>
                        <p>seg Para Cancelar la Solicitud</p>
                        <button className='cancel'>Cancelar Solicitud</button>
                    </div> */}

                    <div className={`${panelTrigger ? 'info-summary__body active' : 'info-summary__body'}`}>
                        <h3><span>Solicitud /</span> {infoFrm.Title} <span className={"state" + (item['Estado'] === 'Finalizado' ? '--confirmed' : '')} > {item['Estado']}</span></h3>{/* process state, add "--confirmed" for green result */}
                        {/* <h2>Solicitud de soporte para optimizar el proceso de facturación</h2> */}
                        <div>
                            {
                                columnsFrm.filter(x => x.displayName !== 'Estado' ).map((columnKey, colIndex) => (
                                    <div key={'columnaShow_' + colIndex}>
                                        <div>
                                            <label>{columnKey.displayName}</label>
                                            <span>{columnKey.description}</span>
                                        </div>
                                        <div>
                                            {
                                                item && 
                                                <CustomCell columnKey={columnKey} rowData={item} />
                                            }
                                            {/* <img src={process.env.PUBLIC_URL + '/assets/posint.svg'} alt="" className=''/> */}
                                        </div>
                                    </div> 
                                ))
                            } 
                            {/* <div>
                                <div>
                                    <label>Archivos Adjuntos</label>
                                </div>
                                <div className='img'>
                                    <div>
                                        <img src={process.env.PUBLIC_URL + '/assets/img-ex.png'} alt="" className=''/>
                                        <span>JPG</span>
                                        <p>Descripción de la imagen que soporta el problema</p>
                                    </div>
                                    <div>
                                        <img src={process.env.PUBLIC_URL + '/assets/img-ex2.png'} alt="" className=''/>
                                        <span>PDF</span>
                                        <p>Descripción de la imagen que soporta el problema</p>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        <div className="show-content" onClick={activePanel}>Desplegar todo el detalle</div>
                    </div>

                </div> :
                <div></div>
            }
        </div>
    )
}